import { APP_INITIALIZER, ApplicationConfig, Injectable } from '@angular/core';
import { NavigationStart, Router, RouteReuseStrategy } from '@angular/router';
import { addSpotterProviders } from '@spotter/providers/spotter-providers';
import { routes } from './app.routes';
import { environment } from './environments/environment';
import { SpotterRouteReuseStrategy } from './services/spotter-route-reuse-strategy';
import { SightingInitialiser } from '@spotter/inits/sighting-initialiser';


// Handles the loader at the beginning
let initialiser_things_to_load = 4;
let initialiser_things_loaded = 0;
function updateLoader() {
    initialiser_things_loaded++;
    let loady = document.getElementById('initial_loader_value');
    if (loady)
    {
        let percent = Math.floor((initialiser_things_loaded / initialiser_things_to_load) * 100);
        loady.style.width = `${percent}%`;
    }
}




export const appConfig: ApplicationConfig = {
    providers: [
      
        { provide: RouteReuseStrategy, useClass: SpotterRouteReuseStrategy },
        {
            provide: APP_INITIALIZER,
            useFactory: (appInitService: SightingInitialiser) => () => appInitService.initialise(updateLoader),
            multi: true,
            deps: [SightingInitialiser]
        },

        addSpotterProviders(routes, environment, updateLoader),
    ]
};
